export const filterContent = {
    category: ["DNEVNI BORAVAK", "KUHINJA", "SPAVAĆA SOBA", "KUPATILO", "HODNIK", "Kitchen","Living-room","Bedroom","Bathroom","Hall", "Hall2", "Hall3"],
    collection: ["OPERA", "MODERN COLLECTION", "DIZAYN", "PLAZA", "ŠPAGASTI", "BAMBOO", "WENICE", "FLORA", "HEREKE", "LOTUS", "SOFT", "IRAN COLLECTION", "ZARA", "SARAJ", "SARAJ COLLECTION"],
    color: [
      { name: "black", code: "bg-dark" },
      { name: "blue", code: "bg-primary" },
      { name: "red", code: "bg-danger" },
      { name: "yellow", code: "bg-warning" },
      { name: "green", code: "bg-success" },
      { name: "dark", code: "bg-gray" },
    ],
    size: ["115x110", "115x75", "110*110"],
};